import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { EditApkContext, IEditApkContext } from 'modules/FirmwareAndApp/Apk/EditApk/editApkState/editApkContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		versionName,
		versionCode,
		description,
		applicationId,
		IDSelectedApkType,
		isCutoverBeforeUpdate,
		fileData,
		filePath,
		initialFormData,
	} = useContext<IEditApkContext>(EditApkContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: versionName || versionCode || description || applicationId || IDSelectedApkType,
	});

	const compareFile = () => {
		if (fileData.fileId) {
			return fileData.fileId;
		}
		if (filePath) {
			return filePath;
		}
		return '';
	};

	const currentFormData = {
		versionName,
		versionCode,
		description,
		applicationId,
		IDSelectedApkType,
		isCutoverBeforeUpdate,
		filePath: compareFile(),
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
